import { cloneDeep } from "lodash";
import { sitesPipelineStore } from "../store";

export const moveSiteWithinStage = ({
  stageId,
  fromIndex,
  toIndex,
}: {
  stageId: string;
  fromIndex: number;
  toIndex: number;
}) => {
  const updatedSiteIds = cloneDeep(sitesPipelineStore.orderedSiteIdsByStageId[stageId]);

  if (!updatedSiteIds) return;
  if (!updatedSiteIds[fromIndex] || !updatedSiteIds[toIndex]) return;

  const [updatedSiteId] = updatedSiteIds.splice(fromIndex, 1);
  updatedSiteIds.splice(toIndex, 0, updatedSiteId);
  sitesPipelineStore.orderedSiteIdsByStageId[stageId] = updatedSiteIds;
};
